module.exports = __webpack_public_path__ + "img/chest_small.e9115920.webp";